// @ts-nocheck
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Card } from './UI';
import { TriangleAlert } from 'lucide-react';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className="p-6">
          <Card className="p-8 text-center text-balance bg-rose-50 border-rose-100 shadow-none">
            <TriangleAlert className="w-12 h-12 text-rose-400 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-rose-900 mb-2">Something went wrong</h2>
            <p className="text-rose-600/80 text-sm mb-6">
              We encountered an unexpected error rendering this view.
            </p>
            <button 
              onClick={() => this.setState({ hasError: false })}
              className="px-6 py-2 bg-white text-rose-600 border border-rose-200 rounded-xl text-sm font-bold shadow-sm hover:bg-rose-50 transition-colors"
            >
              Try Again
            </button>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}
